import { format, parseISO, differenceInDays } from "date-fns";

export const fmtDate = (iso, pattern = "MMM d, yyyy") => {
  if (!iso) return "";
  try {
    return format(parseISO(iso), pattern);
  } catch {
    return iso;
  }
};

export const daysUntil = (iso) => {
  if (!iso) return null;
  try {
    return differenceInDays(parseISO(iso), new Date());
  } catch {
    return null;
  }
};

export const phaseColorVar = (phase) => {
  switch (phase) {
    case "menstrual":
      return "var(--phase-period)";
    case "follicular":
      return "var(--phase-follicular)";
    case "ovulation":
      return "var(--phase-ovulation)";
    case "luteal":
      return "var(--phase-luteal)";
    default:
      return "var(--muted-foreground)";
  }
};

export const phaseLabel = (phase) =>
  phase ? phase.charAt(0).toUpperCase() + phase.slice(1) : "—";
